document.documentElement.classList.add("preloader-active");

document.addEventListener("DOMContentLoaded", function() {

  /* -----------------------------
     1. Universal UL Splitter
  ----------------------------- */
  function splitList(selector, splitIndex = 5, newClass = "second-ul") {
    const $originalUL = $(selector);

    if ($originalUL.length) {
      const $items = $originalUL.children("li");

      // No split if not enough items
      if ($items.length <= splitIndex) return null;

      const originalClasses = $originalUL.attr("class") || "";

      const $newUL = $(
        `<ul role="list" class="${originalClasses} ${newClass}"></ul>`
      );

      $items.slice(splitIndex).appendTo($newUL);

      $newUL.insertAfter($originalUL);

      return $newUL;
    }

    return null;
  }

  // Header
  const $secondHeaderUL = splitList(".hdr-nav-primary-level-ul", 6, "second-ul");

  // Footer
  splitList(".footer-block-linklist-ul ul", 3, "footer-second-ul");

  /* -----------------------------
    1.1 Insert Logo Between Split ULs
        OR Before Main UL if No Split
        (All Pages EXCEPT Homepage)
        + Hide Original ONLY on Desktop
  ----------------------------- */
  if (window.location.pathname !== "/") {

    const $logoBlock = $(
      "#SiteHeaderInner .header-bar--left.header-bar--left-logo-mobile.header-bar--left-logo"
    );

    if ($logoBlock.length) {
      const $clone = $logoBlock.clone(true, true);

      if ($secondHeaderUL) {
        // Case 1: split happened → insert between ULs
        $clone.insertBefore($secondHeaderUL);
      } else {
        // Case 2: split did NOT happen → insert before main UL
        const $mainUL = $(".hdr-nav-primary-level-ul").first();

        if ($mainUL.length) {
          $clone.insertBefore($mainUL);
        }
      }

      // Remove original on desktop only
      if (window.innerWidth > 1025) {
        $logoBlock.remove();
      }
    }
  }





  /* -----------------------------
     2. Loader Fade Out
     ----------------------------- */
  const APP_STABILIZATION_DELAY = 600;

  setTimeout(() => {
    const loader = document.getElementById("site-preloader");
    if (!loader) return;

    loader.style.opacity = "0";
    loader.style.transition = "opacity 400ms ease";

    setTimeout(() => {
      loader.style.display = "none";
      document.documentElement.classList.remove("preloader-active");
    }, 400);
  }, APP_STABILIZATION_DELAY);



  /* -----------------------------
     3. GSAP Parallax Media Sections
     ----------------------------- */
  if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);

    /* VIDEO Parallax */
    const videoWrappers = document.querySelectorAll(".video-parallax-wrapper");

    videoWrappers.forEach(wrapper => {
      const video = wrapper.querySelector("video");
      if (!video) return;

      video.style.height = "160%";
      video.style.willChange = "transform";

      gsap.fromTo(
        video,
        { y: "-40%" },
        {
          y: "40%",
          ease: "none",
          scrollTrigger: {
            trigger: wrapper,
            start: "top bottom",
            end: "bottom top",
            scrub: 1.6,
          }
        }
      );
    });
  }



  /* -----------------------------
   4. Match Product Info Height (Desktop Only)
   ----------------------------- */
function matchProductHeights() {
  const source = document.querySelector(".product-main-top-section");
  const target = document.querySelector(".product.product-main-info-section");

  if (!source || !target) return;

  // Desktop only
  if (window.innerWidth > 1025) {
    const height = source.offsetHeight / 2;
    target.style.height = height + "px";
  } else {
    // Reset on mobile
    target.style.height = "";
  }
}

// Run once + on resize
matchProductHeights();
window.addEventListener("resize", matchProductHeights);


});
